module.exports = __webpack_public_path__ + "static/media/raymond.151cb72d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raymond.jpg
// module id = 97
// module chunks = 0